const routes = {
  path: '/retentions',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/retentions',
      name: 'list-retentions',
      component: () => import('../views/Retention/Index.vue'),
      meta: {
        pageTitle: 'retention.title',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'retention.title', active: true }],
      },
    },
    {
      path: '/retentions/occurrences',
      name: 'retention-occurrences',
      component: () => import('../views/Retention/Occurrences.vue'),
      meta: {
        pageTitle: 'retention.occurrences.launch',
        access_nivel: ['1'],
        breadcrumb: [
          { text: 'retention.title', to: { name: 'list-retentions' } },
          { text: 'retention.occurrences.launch', active: true },
        ],
      },
    },
    {
      path: '/retentions/:id',
      name: 'retention-detail',
      component: () => import('../views/Retention/Detail.vue'),
      meta: {
        pageTitle: 'retention.detail.title',
        access_nivel: ['1'],
        breadcrumb: [
          { text: 'retention.title', to: { name: 'list-retentions' } },
          { text: 'retention.detail.title', active: true },
        ],
      },
    },
  ],
}

export default routes
